import { GREEN } from "@finway-group/shared/lib/consts"
import { Vendor } from "@finway-group/shared/lib/models"
import { Avatar, Skeleton } from "antd"
import React, { useEffect, useState } from "react"

import { doesImageExist } from "Shared/utils/helper.utils"

interface VendorImageInterface {
    size: "small" | "large" | number
    vendor: Vendor
    bordered?: boolean
}

const VendorImage = ({ size = "small", vendor, bordered = false }: VendorImageInterface) => {
    const { id, img } = vendor

    const [imgLoading, setImgLoading] = useState<boolean>(true)
    const [showInitials, setShowInitials] = useState<boolean>(false)

    useEffect(() => {
        const checkImage = async () => {
            setImgLoading(true)
            const imageExists = await doesImageExist(img)
            setImgLoading(false)
            setShowInitials(!imageExists)
        }
        void checkImage()
    }, [img])

    const getNameInitials = () => {
        const fullName = ""

        try {
            return getVendorInitials()
        } catch (error) {
            return fullName
        }
    }

    const getVendorInitials = () => {
        if (vendor.name.length > 1) {
            return vendor.name.substr(0, 2).toUpperCase()
        }
        return vendor.name.charAt(0).toUpperCase()
    }

    const sizeInPx = size === "large" ? 40 : size === "small" ? 24 : size

    const onError = () => {
        setShowInitials(true)
        return false
    }

    return (
        <>
            {imgLoading ? (
                <Skeleton.Avatar
                    key={id}
                    className={`${bordered ? "border p-4 rounded-lg" : "border-none"} min-w-${sizeInPx}  min-h-${sizeInPx}`}
                    active={true}
                    size={size}
                    shape="square"
                />
            ) : showInitials ? (
                <Avatar
                    key={vendor.id}
                    size={size}
                    className={`${bordered ? "border p-4 rounded-lg" : "border-none"} animation-appear min-w-${sizeInPx} min-h-${sizeInPx}`}
                    style={{ color: GREEN, backgroundColor: "#ffffff" }}
                    shape="square"
                >
                    <span className="items-center self-center">{getNameInitials().trim()}</span>
                </Avatar>
            ) : (
                <Avatar
                    key={vendor.id}
                    className={`${bordered ? "border p-4 rounded-lg" : "border-none"} min-w-${sizeInPx}  min-h-${sizeInPx}`}
                    size={size}
                    src={img}
                    shape="square"
                    onError={onError}
                />
            )}
        </>
    )
}

export default VendorImage
